/**
 * @generated SignedSource<<8865a5682fc6edcd9560e2d190fe228a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "changeReferentDocumentOnFrame",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateReferentFrameMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateReferentFrameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "af95843426e4d0f332e0c87959388d51",
    "id": null,
    "metadata": {},
    "name": "UpdateReferentFrameMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateReferentFrameMutation(\n  $ids: [ID]!\n) {\n  changeReferentDocumentOnFrame(ids: $ids) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "219b511f1528bfda4e779736093ea640";

export default node;
